<template>

  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">   
        <div id="errorNotification" class="col-md-12">
          <base-alert v-if="errorMessage != null" type="danger">
              <span class="alert-inner--text"> {{errorMessage}}</span>
              <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
                 <span aria-hidden="true">&times;</span>
              </button>
          </base-alert>
          <base-alert v-if="successMessage != null" type="success">
              <span class="alert-inner--text"> {{successMessage}}</span>
              <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
                 <span aria-hidden="true">&times;</span>
              </button>
          </base-alert>
        </div> 
        <div class="col-md-3">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{_.startCase(currentProfile)}}
          </h3>
        </div>
        <div class="col-md-9 text-right">
          <!-- <base-dropdown class="nav-link pr-0 float-right" position="right">
            <div class="media align-items-center" slot="title">
              <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
            </div>
            <template>
              <div class=" dropdown-header noti-title">
                <h6 class="text-overflow m-0">ACTIONS</h6>
              </div>
              <div class="dropdown-item" @click.prevent="showActionDrawer('print_list')">
                  <i class="fa fa-print"></i>
                  <span>Print</span>
              </div>
              <div class="dropdown-item">
                  <i class="fa fa-upload"></i>
                  <span>Import</span>
              </div>
              <div class="dropdown-item" @click.prevent="showActionDrawer('export_list')">
                  <i class="fa fa-download"></i>
                  <span>Export</span>
              </div>
              <div class="dropdown-item" @click.prevent="showActionDrawer('customize_list')">
                  <i class="fa fa-list-ul"></i>
                  <span>Customize List</span>
              </div>
            </template> 
          </base-dropdown> -->

          <div v-if="checkedItems.length == 0">
           <base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer(0)">+ Add {{_.startCase(currentProfile)}}</base-button>
          </div>
  
          <div v-else>
            <base-button v-if="this.$parent.filterStatus != 'A'" class="float-right ml-1" type="default" size="sm" @click.prevent="massupdate('status','A')">Activate</base-button>
            <base-button v-if="this.$parent.filterStatus != 'I'" class="float-right ml-1" type="default" size="sm" @click.prevent="massupdate('status','I')">Deactivate</base-button> 
            <div class="ml-1"></div>
          </div>
        
        </div>        

      </div>
      
    </div>
    
    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">
       <div v-if="profileAction == 'customize_list'">
         <h6 class="heading-small text-muted mb-4">Customize Fields</h6>
          <ul v-if="availableFields.length > 0" class="list-group list-group-flush" style="width: 100%">
              <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                  <div class="row">
                      <div class="col-md-6">
                          AVAILABLE FIELDS
                      </div>
                      <div class="col-md-6">
                         <a-checkbox @change="onCheckAllField" :checked="fields.length == (availableFields.length + 4)" class="float-right"/>
                      </div>
                   </div>
              </li>
              <li class="list-group-item" style="font-size: 14px" v-for="field in availableFields" :key="field">
                   <div class="row">
                       <div class="col-md-6">
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{field}}
                      </div>
                      <div class="col-md-6">
                          <a-checkbox @change="onCheckField(field)" :checked="fields.includes(field)" class="float-right"/>
                      </div>
                   </div>
              </li>
          </ul>

       </div>

       <div v-if="profileAction == 'export_list'">
         <h6 class="heading-small text-muted mb-4">Export Options</h6>
         <div>
            <base-radio name="0" class="mb-3" v-model="filterStatus" value="O">
                Export All
            </base-radio>
            <base-radio name="1" class="mb-3" v-model="filterStatus" value="1">
                Export Current Page
            </base-radio>
            <base-radio name="2" class="mb-3" v-model="filterStatus" value="2">
                Export Selected
            </base-radio>
            <base-radio name="3" class="mb-3" v-model="filterStatus" value="3">
                Export Filtered
            </base-radio>
          </div>

          <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
            <button type="button" class="btn btn-primary float-right" @click.prevent="download">Export</button> 
          </div>

        </div>

        <div v-if="profileAction == 'print_list'">
          <h6 class="heading-small text-muted mb-4">Print Options</h6>
        </div>
    </a-drawer>

    <a-drawer title="" :width="1000" placement="right" @close="onClose" :visible="visible" :key="componentKey">
        <auto-rep-form v-on:refreshPage="refreshPage"></auto-rep-form>
    </a-drawer>

    <a-drawer title="" :width="600" placement="right" @close="onClose" :visible="historyVisible">

      <a-spin :spinning="exportSpinning" size="large">
        <h6 class="heading-small text-muted mb-4">Run History</h6>
        <a-table
          :columns="runHistoryColumns"
          :dataSource="runHistoryData"
          :pagination="true"
        >
          <template slot="started_at_formatted" slot-scope="text">
            {{ text || '-' }}
          </template>

          <template slot="end_at_formatted" slot-scope="text">
            {{ text || '-' }}
          </template>

          <template slot="remarks" slot-scope="text">
            {{ text || '-' }}
          </template>

          <template slot="actions" slot-scope="record">
            <a-button size="small" type="primary" @click="viewRawData(record)">View Raw Data</a-button> <br>

            <base-dropdown class="nav-link pr-0 float-right" position="right">
              <div class="media align-items-center" slot="title">
                <a-button size="small" type="warning" >Export</a-button>
              </div>
              <template>
                <div class=" dropdown-header noti-title">

                  <h6 class="text-overflow m-0">Export</h6>
                </div>
                <!-- {{record}} -->
                <div class="dropdown-item" @click="exportCSV(record)">
                    <i class="fa fa-download"></i>
                    <span>CSV</span>
                </div>
                <div class="dropdown-item" @click="exportXLSX(record)">
                    <i class="fa fa-download"></i>
                    <span>Excel</span>
                </div>
                <div class="dropdown-item" @click="exportPDF(record)">
                    <i class="fa fa-download"></i>
                    <span>PDF</span>
                </div>
              
              </template> 
            </base-dropdown>
            
          </template>
        </a-table>
      </a-spin>
    </a-drawer>   

    <a-drawer title="" :width="windowWidth" placement="right" @close="onCloseRaw" :visible="rawDataVisible">
      <h6 class="heading-small text-muted mb-4">Auto-replenishment Run: Raw Data</h6>
      <a-table
        :columns="rawDataColumns"
        :dataSource="rawDataValue"
        :pagination="true"
        :scroll="{ y: 400 }"
      ></a-table>
    </a-drawer>

    <div class="table-responsive">
      <vuetable ref="vuetable"
                  :api-url="apiURL"
                  :http-options="httpOptions"
                  :fields="fields"
                  :sort-order="sortOrder"
                  :show-sort-icons="true"
                  :per-page="10"
                  :css="css.table"
                  pagination-path=""
                  data-path="data"
                  @vuetable:checkbox-toggled-all="log"
                  @vuetable:checkbox-toggled="log"
                  @vuetable:load-error="onLoadError"
                  @vuetable:pagination-data="onPaginationData">   
                    <template slot="actions" slot-scope="props">
                        <center>
                        <div class="table-button-container">
                            <button class="btn btn-warning btn-sm" @click.prevent="showDrawer(props.rowData.id)">Edit</button>
                            <button class="btn btn-danger btn-sm" @click.prevent="deleteRow(props.rowData.id)">Delete</button>
                            <button class="btn btn-success btn-sm" @click.prevent="showHistory(props.rowData)">History</button>
                            <a-popconfirm title='Are you sure you want to manually trigger auto-replenishment?' class="btn btn-primary btn-sm" @confirm="() => runAutoRep(props.rowData)">
                                Run
                            </a-popconfirm>                            
                        </div>
                        </center>
                    </template>

                </vuetable>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="pagination ui basic segment grid">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination"></vuetable-pagination>
      </div>
    </div>

  </div>
</template>

<script>
  import axios from "axios";
  import { mapState, mapActions } from 'vuex'  
  import Vuetable from "vuetable-2/src/components/Vuetable";
  import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
  import secureStorage from '../../controllers/secureStorage';
  import HTTPRequest from '../../controllers/httpRequest.js'
  import AutoRepForm from '../Auto-Replenishment/AutoReplenishmentForm.vue' 

  import * as XLSX from "xlsx";
  import jsPDF from "jspdf";
  import autoTable from "jspdf-autotable";
  
  
  var component_x;
  
  export default {
    name: 'profiles-table',
    props: {
      type: {
        type: String
      },
      title: String
    },
    components: {
        Vuetable,
        VuetablePagination,
        AutoRepForm
    },
    computed: {
        ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'profileId', 'parameters']),
    },
    data() {
      return {
        exportSpinning: false,
        windowWidth: 0,
        historyVisible: false,
        rawDataValue: [],
        rawDataColumns: [
          // { title: 'Computed At', dataIndex: 'computed_at', key: 'computed_at' },
          { title: 'Site', dataIndex: 'site_name', key: 'site_name' },
          { title: 'Replenishment Priority', dataIndex: 'replenishment_priority', key: 'replenishment_priority' },
          { title: 'Product', dataIndex: 'product_name', key: 'product_name' },
          { title: 'Sales Qty', dataIndex: 'sales_qty', key: 'sales_qty' },
          { title: 'Source Site On-hand Qty', dataIndex: 'wh_onhand_qty', key: 'wh_onhand_qty' },
          { title: 'Ordering Cost', dataIndex: 'ordering_cost', key: 'ordering_cost' },
          { title: 'Landed Cost', dataIndex: 'landed_cost', key: 'landed_cost' },
          // { title: 'Hash Value', dataIndex: 'hash_value', key: 'hash_value' },
          { title: 'Allocated Qty', dataIndex: 'allocated_qty', key: 'allocated_qty' },
          { title: 'Supplier', dataIndex: 'supplier_name', key: 'supplier_name' },
          { title: 'Min Qty', dataIndex: 'min_qty', key: 'min_qty' },
          { title: 'Max Qty', dataIndex: 'max_qty', key: 'max_qty' },
          { title: 'Site Onhand Qty', dataIndex: 'site_onhand_qty', key: 'site_onhand_qty' },
          { title: 'Status', dataIndex: 'status', key: 'status' },
          { title: 'Remarks', dataIndex: 'remarks', key: 'remarks' }
        ],

        rawDataVisible: false,
        runHistoryData: [],
        runHistoryColumns: [
          {
            title: "Start at",
            dataIndex: "started_at_formatted",
            scopedSlots: { customRender: "started_at_formatted" },
          },
          {
            title: "End at",
            dataIndex: "end_at_formatted",
            scopedSlots: { customRender: "end_at_formatted" },
          },
          {
            title: "Remarks",
            dataIndex: "remarks",
            scopedSlots: { customRender: "remarks" },
          },
          {
            title: "Actions",
            key: "actions",
            scopedSlots: { customRender: "actions" },
          },
        ],

        filterStatus: "",
        profileAction: "",
        checkedFields: [],
        checkedItems: [],
        availableFields: [],
        errorMessage: null,
        successMessage: null,
        componentKey: 0,
        drawerVisible: false,
        visible: false,
        apiURL: "",
        fields: [
          '__checkbox',
          { name: "id", title: "ID" },
          { name: "name", title: "Name" },
          { name: "code", title: "Code" },
          { 
            name: "output_document_type", 
            title: "Output Document Type",
            callback: "formatOutputDocType"
          },
          { 
            name: "replenishment_type", 
            title: "Replenishment Type",
            callback: "formatReplenishmentType"
          },
          { 
            name: "schedule", 
            title: "Schedule",
            callback: "formatSchedule"   
          },
          // { name: "schedule", title: "Schedule" },
          { name: "status", title: "Status" },
          '__slot:actions'
        ],
        sortOrder: [
          {
            field: "id",
            direction: "asc"
          }
        ],
        httpOptions:{
            headers: {
                Authorization: 'Bearer ' + secureStorage.getItem("accessToken") , 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
            }
        },
        css: {
            table: {
              tableClass: 'table table-sm table-striped table-bordered table-hovered',
              loadingClass: 'loading'
            },
            pagination: {
              infoClass: 'pull-right',
              wrapperClass: 'vuetable-pagination pull-right',
              activeClass: 'btn-primary btn-sm',
              disabledClass: 'disabled',
              pageClass: 'btn btn-border',
              linkClass: 'btn btn-border',
              icons: {
                first: '',
                prev: '',
                next: '',
                last: '',
              },
            }
        } 
      }
    },
    watch: {
      currentApiURL: function() {
        this.$refs.vuetable.resetData()
        this.apiURL = this.currentApiURL
      },
      parameters: function() {
        this.apiURL = this.currentApiURL
        this.apiURL = this.apiURL + this.parameters
        this.$refs.vuetable.selectedTo = []
        this.checkedItems = []
      }
    },
    methods: {

        ...mapActions(['updateProfileId']),

        async exportCSV(record) {
          this.exportSpinning = true;

          const response = await HTTPRequest.getRequest(
            this.endPoint + "auto_replenishment_histories/" + record.id + "/get_auto_replenishment_data",
            null
          );
          this.rawDataValue = response;

          const headerRow = this.rawDataColumns.map(c => c.title);
          const rows = this.rawDataValue.map(item =>
            this.rawDataColumns.map(col =>
              item[col.dataIndex] !== undefined && item[col.dataIndex] !== null
                ? item[col.dataIndex]
                : ""
            )
          );

          const worksheet = XLSX.utils.aoa_to_sheet([headerRow, ...rows]);
          const csv = XLSX.utils.sheet_to_csv(worksheet);

          const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
          const url = URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = url;
          link.download = `auto_replenishment_${record.auto_replenishment_id}_run_${record.id}.csv`;
          link.click();

          URL.revokeObjectURL(url);

          this.exportSpinning = false;
        },

        // ============================
        // EXPORT XLSX
        // ============================
       async exportXLSX(record) {
          this.exportSpinning = true;

          const response = await HTTPRequest.getRequest(
            this.endPoint + "auto_replenishment_histories/" + record.id + "/get_auto_replenishment_data",
            null
          );
          this.rawDataValue = response;

          const headerRow = this.rawDataColumns.map(c => c.title);
          const rows = this.rawDataValue.map(item =>
            this.rawDataColumns.map(col =>
              item[col.dataIndex] !== undefined && item[col.dataIndex] !== null
                ? item[col.dataIndex]
                : ""
            )
          );

          const worksheet = XLSX.utils.aoa_to_sheet([headerRow, ...rows]);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

          XLSX.writeFile(workbook, `auto_replenishment_${record.auto_replenishment_id}_run_${record.id}.xlsx`);
          this.exportSpinning = false;
        },


        // ============================
        // EXPORT PDF
        // ============================
        async exportPDF(record) {

          this.exportSpinning = true
          var response = await HTTPRequest.getRequest(
              this.endPoint +  "auto_replenishment_histories/"+  record.id+"/get_auto_replenishment_data",
              null
          );

          this.rawDataValue = response
          const doc = new jsPDF("landscape");

          // Convert Ant Design column config → PDF headers
          const columns = this.rawDataColumns.map(col => ({
            header: col.title,
            dataKey: col.dataIndex,
          }));

          autoTable(doc, {
            columns,
            body: this.rawDataValue,
            theme: "grid",
            headStyles: { fillColor: [0, 0, 0] },
            styles: { fontSize: 8 },
          });

          doc.save(`auto_replenishment_${record.auto_replenishment_id}_run_${record.id}.pdf`);
          this.exportSpinning = false
        },

        formatSchedule(value) {
          const scheduleMap = {
            "0 0 1 * ? *": "First day of the month",
            "0 0 L * ? *": "Last day of the month",
            "MANUAL": "MANUAL"
          };

          if (scheduleMap[value]) {
            return scheduleMap[value];
          }

          // Handle weekly cron e.g. "0 0 ? * MON *" 
          const parts = value.trim().split(/\s+/);
          if (
            parts.length === 6 &&
            parts[0] === "0" &&
            parts[1] === "0" &&
            parts[2] === "?" &&
            parts[3] === "*" &&
            parts[4] !== "*"   
          ) {
            return `Every week on ${parts[4]}`; // e.g. MON, TUE
          }

          return value; // fallback (unmapped cron)
        },

        getWindowWidth(event) { //for fullscreen drawer
            this.windowWidth = window.innerWidth
        },
        async viewRawData(record){

          var response = await HTTPRequest.getRequest(
              this.endPoint +  "auto_replenishment_histories/"+  record.id+"/get_auto_replenishment_data",
              null
          );

          this.rawDataValue = response
          this.rawDataVisible = true

        },
        formatOutputDocType(value) {
          switch (value) {
            case "OTHTRA": return "Transfer Allocation";
            case "ORIPOX": return "Purchase Order";
            default: return value || "-";
          }
        },
        formatReplenishmentType(value) {
          switch (value) {
            case 1: return "Offtake (Sales)";
            case 2: return "Min/Max Quantity";
            default: return value || "-";
          }
        },

        refreshPage(){
          this.onClose()
          this.$refs.vuetable.refresh()
          this.successMessage = "Successful Operation"
          this.errorMessage = null
        },
        showDrawer(id) {
          this.componentKey++
          this.updateProfileId(id)
          this.visible = true
        },
        showHistory(data) {
          this.componentKey++
          this.historyVisible = true
          this.runHistoryData = data.auto_replenishment_histories
        },
        async runAutoRep(autoRep) {
          if(autoRep.status != "A"){
            this.$notification['warning']({
              message: "Cannot proceed",
              description: "Auto-replenishment is not active."
            });
            return 0;
          }

          let id = autoRep.id
          try {
            const response = await HTTPRequest.putRequest(
              this.endPoint + this.currentProfile + "/" + id + "/run_autorep",
              null
            );

            console.log("Lambda Trigger Response:", response);

            this.$notification['success']({
              message: "Action Successful",
              description: "Auto-replenishment triggered. Please monitor run history."
            });

          } catch (error) {
            console.error("Error triggering auto-replenishment:", error);

            let errorMessage = "An unexpected error occurred while triggering auto-replenishment.";

            // Check for backend-provided error
            if (error.response.data.error) {
              errorMessage = error.response.data.error;
            }

            this.$notification['error']({
              message: "Trigger Failed",
              description: errorMessage
            });
          }
        },
        async showActionDrawer(action) {
          if (action == "customize_list") {
            var response = await HTTPRequest.getRequest(
              this.endPoint + this.currentProfile + "/get_viewable_fields",
              null
            );
            
            let unsortedFields = response["fields"];
            let sortedFields = this.checkedFields.slice();

            unsortedFields.forEach(fieldName => {
              if (!this.checkedFields.includes(fieldName))
                sortedFields.push(fieldName)
            });

            this.availableFields = sortedFields;

          }
          this.profileAction = action;
          this.drawerVisible = true;
        },
        onClose() { 
          this.drawerVisible = false
          this.visible = false
          this.historyVisible = false
          this.componentKey++
        },
        onCloseRaw(){
          this.rawDataVisible = false
          this.rawDataValue = []
        },
        log(){
          this.checkedItems = this.$refs.vuetable.selectedTo
        },
        onCheckField(fieldName){
          if(this.fields.includes(fieldName)){
            var indexValue = this.fields.indexOf(fieldName)
            if(indexValue > -1) this.fields.splice(indexValue,1)
            var indexValue2 = this.checkedFields.indexOf(fieldName)
            if(indexValue2 > -1) this.checkedFields.splice(indexValue2,1)
          } else {
            this.fields.pop()
            this.fields.push(fieldName)
            this.fields.push("__slot:actions")
            this.checkedFields.push(fieldName)
          }
          // console.log(this.fields)
          localStorage.setItem("productProfileCustomList", JSON.stringify(this.checkedFields))
          this.$refs.vuetable.normalizeFields()
        },
        onCheckAllField(){
        },
        async massupdate(field_name,value){
          var field_update = {}
          field_update[field_name] = value
          var payload = {ids: this.checkedItems, field_update: field_update }
          var response = await HTTPRequest.postRequest(this.endPoint + this.currentProfile + "/mass_update" , null, payload)   
          if(response["message"] == "Ok"){
              this.successMessage = "Update successful!"
              this.$refs.vuetable.refresh()
              this.checkedItems = []
              this.$refs.vuetable.selectedTo = []
          } else {
              this.successMessage = "Update failed!"
              // alert("Error processing")
          }
        },
        onPaginationData(paginationData) {
          this.$refs.pagination.setPaginationData(paginationData);
        },
        async onLoadError(error){
          // request for new token or reauthenticate
          if(error.response.status == 401){
            var  auth_response = await HTTPRequest.authenticate(component_x.endPoint)   
            if(auth_response["status"] == "Ok"){
              this.$router.go();
            }else{
              alert("Cannot get access token. Please login again.")
              this.$router.push("/")
            }
          }   
        },
        onChangePage(page) {
          this.$refs.vuetable.changePage(page);
        },
        deleteRow(id){
            axios({
            method: 'delete',
            url: this.endPoint + this.currentProfile +'/' + id,
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
            })
            .then(function () {
                component_x.successMessage = "Successfully deleted record"
                component_x.$refs.vuetable.refresh()
            })
            .catch(function () {
                alert("Invalid Credentials")
            });
        },
        download(){
          var payload = {}
          var additional_parameters = ""
          var baseUrl = this.currentApiURL + "/download?file_type=csv"
          if(this.filterStatus == "0"){
            // All
            payload["type"] = "all"
          }else if(this.filterStatus == "1"){
            // Current Page
            payload["type"] = "current_page"
            additional_parameters = this.parameters
            additional_parameters = additional_parameters + "&page=" + this.$refs.vuetable.currentPage + "&per_page=" + this.$refs.vuetable.perPage
          }else if(this.filterStatus == "2"){
            // Selected
            payload["type"] = "selected"
            payload["ids"] = this.checkedItems
          }else{
            // Filtered
            payload["type"] = "filtered"
            additional_parameters = this.parameters
          }
          
          var exportFields = this.fields
          var cbIndex = this.fields.indexOf("__checkbox");
          if(cbIndex > -1) exportFields.splice(cbIndex,1) 
          var actionIndex = this.fields.indexOf("__slot:actions"); 
          if(actionIndex > -1) exportFields.splice(actionIndex,1)

          payload["fields"] = exportFields
          additional_parameters = additional_parameters.replace('?','&');

          axios({
            url: baseUrl + additional_parameters ,
            method: 'POST',
            responseType: 'blob', // important
            headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")},
            data: payload,
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'file.csv');
            document.body.appendChild(link);
            link.click();
            this.onClose();
            this.filterStatus = null
            this.successMessage = "Download successful"
          });
        },
        displayMessage( message ){
          if(message["error"] != undefined){
            this.onClose()
            this.errorMessage = message["error"]
            this.successMessage = null
          }
        },
        removeMessage( type ){
          if(type == 'error')
            this.errorMessage = null
          else
            this.successMessage = null
        }
    },
    beforeMount: async function(){
      const productProfileCustomList = localStorage.productProfileCustomList
      // console.log(productProfileCustomList)
      if(productProfileCustomList != undefined && productProfileCustomList != null && productProfileCustomList != "[]"){
        this.checkedFields = JSON.parse(productProfileCustomList)
        this.fields = JSON.parse(productProfileCustomList)
        this.fields.push("__slot:actions")
      }else{
        localStorage.removeItem("productProfileCustomList")
      }

      this.getWindowWidth()
    },
    mounted: function() {
        component_x = this;
        this.apiURL = this.currentApiURL
    }
  }
</script>

<style scoped>
</style>
